import React from "react";
import { Carousel } from "../Carousel";
import { earningsImages } from "../../data/story";
export function Results() {
  return <section className="border-y border-line bg-coal" data-id="element-177" data-mp="12xdyzwinvpqb">
      <div className="mx-auto grid max-w-7xl items-center gap-10 px-5 py-16 sm:px-6 md:grid-cols-[1.2fr_1fr] md:gap-20 md:py-28" data-id="element-178" data-mp="170sjazdmus9k">
        <div data-id="element-179" data-mp="1byc6iosb6fdn">
          <h2 className="font-display text-4xl font-black uppercase leading-[0.95] md:text-6xl" data-id="element-180" data-mp="1bz3sd7w3syqq">
            Hoy, ese sistema genera más de <span className="text-accent" data-id="element-181" data-mp="f7johllted98">$40,000</span> al mes.
          </h2>
          <div className="mt-8 space-y-3 text-lg leading-relaxed text-paper/70" data-id="element-182" data-mp="jb7vo36jb6ty">
            <p data-id="element-183" data-mp="o99hgvvchk94">Pero si solamente te enseño esta captura…</p>
            <p data-id="element-184" data-mp="t1az6xba836j">te estaría enseñando el final de la historia.</p>
            <p className="text-xl font-semibold text-paper" data-id="element-185" data-mp="t2uhetgi0oay">Y yo quiero enseñarte el camino.</p>
          </div>
        </div>
        <div className="mx-auto w-full min-w-0 max-w-[300px] md:max-w-sm" data-id="element-186" data-mp="k6zto0pnrem">
          <Carousel images={earningsImages} label="Capturas de ganancias reales" aspect="aspect-[9/16]" showCaption={false} frameClassName="bg-ink" data-id="element-187" data-mp="idq1zuswr2e" />
        </div>
      </div>
    </section>;
}